import { render, staticRenderFns } from "./parcelle.vue?vue&type=template&id=466da8e2"
import script from "./parcelle.js?vue&type=script&lang=js&external"
export * from "./parcelle.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports